import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReportService } from 'src/app/shared/services/report.service';

@Component({
  selector: 'app-report-deletion-log-modal',
  templateUrl: './report-deletion-log-modal.component.html',
  styleUrls: ['./report-deletion-log-modal.component.scss']
})
export class ReportDeletionLogModalComponent implements OnInit {

  logs: any[] = [];
  displayedColumns = [
    'inspectionId',
    'userName',
    'dateRegister',
    'status',
    'message'
  ];

  constructor(
    private dialogRef: MatDialogRef<ReportDeletionLogModalComponent>,
    private reportService: ReportService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.carregarLogs();
  }

  carregarLogs(): void {
    this.spinner.show();

    this.reportService.getReportDeletionLogs(10).subscribe({
      next: (response) => {
        this.logs = response?.data || [];
      },
      error: () => {
        this.logs = [];
      },
      complete: () => this.spinner.hide()
    });
  }

  async exportCsv(): Promise<void> {
    this.spinner.show();

    try {
      const blob = await this.reportService.exportReportDeletionLogs();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `report-deletion-logs-${this.getNow()}.csv`;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      // futuramente pode plugar toastr/snackbar aqui
      console.error('Erro ao exportar CSV', error);
    } finally {
      this.spinner.hide();
    }
  }

  fechar(): void {
    this.dialogRef.close();
  }

  private getNow(): string {
    const now = new Date();

    const pad = (n: number) => n.toString().padStart(2, '0');

    return `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
  }
}
